import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=2fb6c624&scoped=true"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=2fb6c624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6c624",
  null
  
)

export default component.exports